import React from "react";
import { ClientePJProp } from ".";
import { obterDadosPessoaisPJ } from "../../services/cliente";
import { obterDadosUsuario2 } from '../../services/cookies'
import { executarRequisicaoAutenticada, SessaoExpiradaError } from "../../services/authenticatedRequest";

export const obterDadosPessoais = async (setDadosCadastrais: React.Dispatch<ClientePJProp>, setLoading: React.Dispatch<boolean>, setDesconectar: React.Dispatch<boolean>, setErro: React.Dispatch<boolean>) => {

    setLoading(true)
    setDesconectar(false)
    setErro(false)

    const { id } = obterDadosUsuario2()

    if (!id) {
        setDesconectar(true)
        setLoading(false)
        return
    }

    try {
        const res = await executarRequisicaoAutenticada((token) => obterDadosPessoaisPJ(token, id))
        setDadosCadastrais(res.data.resultado.dadosPessoais)
    } catch (error) {
        if (error instanceof SessaoExpiradaError) {
            setDesconectar(true)
        } else {
            setErro(true)
        }
    } finally {
        setLoading(false)
    }
}
